<template>
  <v-row class="mx-2">
    <v-col :style="{ 'padding-left': padding }">
      <v-col
        cols="12"
        md="8"
        sm="6"
        xs="4"
        style="max-width: 100%"
        class="d-flex justify-space-between mx-auto"
      >
        <v-btn color="info" text class="my-auto pl-0" @click="goToSchedule">
          <v-img
            src="@/assets/icons/anterior.png"
            style="cursor: pointer"
            alt="anterior"
            max-width="30"
            max-height="30"
            dark
          />Permiso
        </v-btn>
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="showCard">
        <CardsView
          :items="holidays"
          :openDialog="openDialog"
          :title="title"
          :showEdit="false"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
      <div v-else>
        <TableWithSearch
          :items="holidays"
          :headers="allHeaders"
          :title="title"
          :openDialog="openDialog"
          :showEdit="false"
          @headersUpdated="updateHeaders"
          @refreshItems="refreshItems"
          :showRefresh="true"
        />
      </div>
    </v-col>
    <v-dialog
      v-model="openHoliday"
      max-width="550px"
      persistent
      @keydown.esc="reset(false)"
    >
      <Form
        @save="saveForm"
        @cancel="reset"
        :maxWidth="maxWidth"
        :mode="mode"
        :show="true"
        :itemsSelect="dataSelected"
        :multiple="true"
      >
      </Form>
    </v-dialog>
    <DeleteDialog
      :showDialog="openDelete"
      :title="titleDelete"
      :confirmDelete="deleteItem"
      :cancelDelete="cancelDelete"
      :maxWidth="'400px'"
    />
    <Snackbar :alert="alert" :color="color" :textAlert="textAlert" />
  </v-row>
</template>
<script>
import schedules from "@/store/permisosDeAcceso/accessPermissions";
import holidays from "@/store/permisosDeAcceso/holidays";
import CardsView from "@/components/Complement/CardsView.vue";
import TableWithSearch from "@/components/Complement/TableWithSearch.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import Form from "@/components/Complement/Form.vue";
import DeleteDialog from "@/components/Complement/DeleteDialog.vue";
import Snackbar from "@/components/Complement/Snackbar.vue";
import configTable from "@/store/configuracionDeTablas/configTable.js";

export default {
  components: {
    CardsView,
    TableWithSearch,
    ButtonsCardList,
    Form,
    DeleteDialog,
    Snackbar,
  },

  data() {
    return {
      showCard: true,
      title: this.$tc("schedules.holidaysGroup"),
      titleTable: "PermisosDeAcceso__TiposDeFeriados",
      color: "",
      titleDelete: this.$tc("schedules.holidaysGroup"),
      headers: [
        {
          text: "Feriados",
          value: "name",
          class: "primary secondary--text",
          visible: true,
        },
        {
          text: "Acciones",
          value: "actions",
          class: "primary secondary--text",
          visible: true,
          sortable: false,
          width: "100px",
        },
      ],
      maxWidth: "550px",
      typeForm: "",
      itemToDelete: {},
      itemId: null,
      alert: false,
      textAlert: "",
    };
  },
  async mounted() {
    configTable.commit("setColums", []);
    let nameTable = this.titleTable;
    configTable
      .dispatch("getColumsTableName", nameTable)
      .then(() => {
        if (configTable.state.colums.length === 0 || configTable.state.colums.length !== this.headers.length ) {
          this.saveConfigColumns();
        }
      })
      .catch((error) => {
        console.error("Error occurred:", error);
      });
    await holidays.dispatch("getHolidays");
  },
  computed: {
    allHeaders() {
      return configTable.state.colums;
    },
    allHolidays() {
      const allHolidays = holidays.state.holidays;
      const selectedHolidays = holidays.state.holidaysId;

      return allHolidays.filter(
        (holiday) =>
          !selectedHolidays.some(
            (selectedHoliday) => selectedHoliday.id === holiday.id
          )
      );
    },
    holidays() {
      return holidays.state.holidaysId;
    },
    padding() {
      return schedules.state.paddingNav;
    },
    scheduleId() {
      return schedules.state.scheduleId;
    },
    openHoliday: {
      get() {
        return holidays.state.openHolidays;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    mode: {
      get() {
        return holidays.state.mode;
      },
      set(newValue) {
        return newValue;
      },
    },
    openDelete: {
      get() {
        return holidays.state.openDelete;
      },
      set(newvalue) {
        return newvalue;
      },
    },
    dataSelected() {
      return [
        {
          name: "holidays",
          label: this.$tc("schedules.holidaysGroup"),
          data: null,
          items: this.allHolidays,
          itemsValue: "id",
          itemsText: "name",
          rules: [
            (v) =>
              (v !== null && v !== undefined && v !== "") ||
              this.$tc("editRegistrations.requerid"),
          ],
        },
      ];
    },
  },

  methods: {
    async refreshItems() {
      if (schedules.state.permissionId) {
        await holidays.dispatch("getHolidaysId", schedules.state.permissionId);
      }
    },
    updateHeaders(headers) {
      const updatedColums = headers;
      configTable.commit("setColums", updatedColums);
      this.saveConfigColumns();
    },
    saveConfigColumns() {
      let columnsToSave = configTable.state.colums;
      if (columnsToSave === undefined || this.allHeaders.length !== this.headers.length  || columnsToSave.length === 0) {
        columnsToSave = this.headers;
      }

      const configData = {
        operId: Number(localStorage.getItem("operId")),
        nameTable: this.titleTable,
        json: JSON.stringify(columnsToSave),
      };
      configTable.commit("setNew", configData);
      configTable.dispatch("new").then(() => {
        configTable.commit("setNew", []);
      });
    },
    saveForm(items) {
      const id = items.holidays
        .split(",")
        .map((numberString) => parseInt(numberString));
      const names = id.map((id) => {
        const holiday = holidays.state.holidays.find(
          (holiday) => holiday.id === id
        );
        return holiday ? holiday.name : "";
      });
      let payload = {
        holidays: id,
        permissionId: this.itemId,
        holidaysName: names,
      };
      this.addHoliday(payload);
    },

    goToSchedule() {
      schedules.dispatch("handleShowWindow", "schedule");
    },
    reset(value) {
      holidays.commit("setOpenHolidays", value);
      this.dataSelected[0].data = null;

      this.alert = false;
    },
    openDialog(type, item) {
      this.typeForm = type;
      this.itemId = schedules.state.permissionId;
      switch (this.typeForm) {
        case "add":
          holidays.commit("setMode", this.$tc("schedules.addHoliday"));
          holidays.commit("setOpenHolidays", true);
          break;

        case "delete":
          holidays.commit("setOpenDelete", true);
          this.itemToDelete.id = item.id;
          break;
        default:
          break;
      }
    },

    cardView(value) {
      this.showCard = value;
    },
    addHoliday(items) {
      holidays.commit("setNew", items);
      holidays
        .dispatch("new")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.addHolidaySuccess");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.reset(false);
    },
    editHoliday(items) {},
    deleteItem() {
      this.itemToDelete = {
        ...this.itemToDelete,
        permissionId: this.itemId,
      };
      holidays.commit("setDeleteItem", this.itemToDelete);
      holidays
        .dispatch("delete")
        .then(() => {
          this.alert = true;
          this.color = "#82A1D0";
          this.textAlert = this.$tc("schedules.deleteHolidaySuccess");
        })
        .catch((e) => {
          this.alert = true;
          this.color = "#FF8D58";
          this.textAlert = e.response.data.error.message;
        });
      this.cancelDelete();
    },
    cancelDelete() {
      holidays.commit("setOpenDelete", false);
      this.alert = false;
    },
  },
};
</script>
<style scoped></style>
